import {useCallback} from "react";
import {postSubmit} from "@ui-seeker/utils";

import {GROUPED_BY} from "@constants";
import {commonFiltersValue} from "@signals";
import {usePricingDiscountRoleConfig} from "../../../@hooks";
import {isLoadingPriceDiscountModalData, priceDiscountModalData} from "../../../@signals";


export default function usePriceDiscountCandlestickModal(discount, groupedID, externalSeller) {
	const { urlApi } = usePricingDiscountRoleConfig()

	const handleSubmit = useCallback(() => {
		isLoadingPriceDiscountModalData.value = true
		postSubmit(`${urlApi}/candlestick-details`, { 
			...commonFiltersValue.value, discount,
			externalSeller : externalSeller ? commonFiltersValue.value.groupedBy === GROUPED_BY.RETAILER : null,
			...commonFiltersValue.value.groupedBy === GROUPED_BY.COUNTRY && { country: [groupedID] },
			...commonFiltersValue.value.groupedBy === GROUPED_BY.RETAILER && { retailer: [groupedID] },
			...commonFiltersValue.value.groupedBy === GROUPED_BY.BRAND && { brand: [groupedID] },
			...commonFiltersValue.value.groupedBy === GROUPED_BY.CATEGORY && { category: [groupedID] }
		})
			.then(res => priceDiscountModalData.value = { ...res, discount })
			.finally(() => isLoadingPriceDiscountModalData.value = false)
	}, [discount, groupedID])

	return {
		handleSubmit
	}

}